<template>
  <div id="unsupported-view">
    <div class="brandlogo-area bg-lg">
      <div class="brandlogo-area__in">
        <div class="brandlogo-area__logo">
          <img src="../assets/images/plogo_bk.svg" alt="Panasonic" />
        </div>
      </div>
    </div>

    <div class="unsupported-title">
      {{ $t("unsupported.title") }}
    </div>

    <div class="unsupported-img-wrapper">
      <img
        v-if="$getI18nImage(qrUnsupportedBaseName)"
        :src="$getI18nImage(qrUnsupportedBaseName)"
        class="unsupported-img"
        alt="unsupported"
      />
    </div>
    <div class="unsupported-message">
      {{ $t("unsupported.message") }}
    </div>
  </div>
</template>

<script>
import store from "@/utils/store";

export default {
  components: {},
  data() {
    return {
      qrUnsupportedBaseName: "",
      // 多言語画像のURL保持
      i18n_qr_unsupported_png: "",
    };
  },
  computed: {},
  watch: {
    // 言語変更を監視
    $currentLocale() {
      this.loadImages();
    },
  },
  mounted() {
    // QRコードファイル名
    this.qrUnsupportedBaseName =
      process.env.NODE_ENV === "production"
        ? "prd_qr_unsupported"
        : "stg_qr_unsupported";
    // 初回画像読み込み
    this.loadImages();
  },
  methods: {
    async loadImages() {
      // このページで使用する画像を並列読み込み
      await Promise.all([
        this.$loadI18nImage(
          this.qrUnsupportedBaseName,
          store.getLocaleByCountry(store.currentCountry.value),
        ),
      ]);
    },
  },
};
</script>

<style>
#unsupported-view {
  /* 画面全体を覆うようにレイアウトを設定 */
  margin: 0px;
  padding: 0px;
  width: 100vw;
  min-height: 100svh;
}

.unsupported-title {
  height: auto;
  margin-top: 24px;
  margin-right: 16px;
  margin-left: 16px;

  text-align: center;
  font: normal normal normal 20px/28px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;

  background-image: var(--title-bg);
}

.unsupported-img-wrapper {
  width: 100vw;
  height: 180px;
  margin-top: 58px;
}

.unsupported-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.unsupported-message {
  margin-top: 55px;
  margin-right: 16px;
  margin-left: 16px;
  height: auto;
  text-align: center;
  font: normal normal normal 16px/24px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

/* ヘッダー */
.brandlogo-area.bg-lg {
  background-color: #f2f2f2;
}
.brandlogo-area__in {
  max-width: 1280px;
  margin: auto;
  display: flex;
  align-items: center;
  height: 42px;
}
.brandlogo-area__logo img {
  max-width: 100%;
  height: 36px;
  display: block;
}

@media (min-width: 981px) {
  .brandlogo-area {
    padding-inline: 20px;
  }
}
@media (max-width: 980px) {
  .brandlogo-area {
    padding-inline: 15px;
  }
}
</style>
